import { PersonStore } from "../../../store/modules/person";
import { ConfigStore } from "../../../store/modules/config";
import { ContractsStore } from "../../../store/modules/contracts";
import { DiTokens } from "../../../services/diTokens";
import { getModule } from "vuex-module-decorators";
import { OperationVue } from "../OperationVue";
import IOperationService from "../../../services/operations/IOperationService";
import { container } from "@/inversify.config";
import { C2BBindingOperationModel } from "../../../models/operations/sbp/C2BBindingOperationModel";

export class C2BBindingOperationVue extends OperationVue {
  /** Стор профиля */
  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  get aliasLoading(): boolean {
    return this.personStore.loading;
  }

  get personInfo() {
    return this.personStore.personInfo;
  }

  public statusText: string = "";

  public finalView: boolean = false;

  valid: boolean = true;

  /** Стор профиля */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  get contracts(): any {
    return this.contractsStore.contracts.getSbpInContracts();
  }

  /**Инициализация операции */
  async initOperation(): Promise<void> {
    this.loading = true;
    this.service = container.get<IOperationService>(DiTokens.C2BBindingOperationService);
    this.OperationModel = (await this.service.init(
      this.configStore,
      this.personStore,
      this.$route.params.qrId.toString()
    )) as C2BBindingOperationModel;

    if((this.OperationModel as C2BBindingOperationModel).IsBindingNameExists) {
      this.statusText = `Привязка счета для ТСП '${(this.OperationModel as C2BBindingOperationModel).MerchantName}' уже существует`;
      this.finalView = true;
    }
    this.loading = false;
  }

  /**Метод для выполнения после успешного проведения */
  async afterExecute(): Promise<void> {
    this.statusText = "Привязка счета оформлена";
    this.finalView = true;
  }

  /**Закрытие формыы */
  async destroyForm(): Promise<void> {
    window.open((this.OperationModel as C2BBindingOperationModel).RedirectUrl,"_blank");
    this.$router.push("/");
    await this.clearForm();
    this.$emit("hideSelf");
  }

  async back() {
    (this.OperationModel as C2BBindingOperationModel).Success = false;
    await this.service.execute(this.OperationModel);
    this.statusText = `Привязка счета не оформлена`;
    this.finalView = true;
  }
}
